export const DIMENSION_GERAL = 'geral';
export const DIMENSION_TIPO_PAGAMENTO = 'tipoPagamento';
export const DIMENSION_INSPECAO = 'inspecao';
export const DIMENSION_CARTAO = 'cartao';

export const SEGMENT_ALL = 'ALL';

export const DIMENSION_TABS = [
  { id: DIMENSION_GERAL, label: 'Geral' },
  { id: DIMENSION_TIPO_PAGAMENTO, label: 'Tipo Pagamento' },
  { id: DIMENSION_INSPECAO, label: 'Inspeção' },
  { id: DIMENSION_CARTAO, label: 'Cartão' },
];

export const DIMENSION_TO_SEGMENTOS_KEY = {
  [DIMENSION_TIPO_PAGAMENTO]: 'tipoPagamento',
  [DIMENSION_INSPECAO]: 'inspecao',
  [DIMENSION_CARTAO]: 'cartao',
};

export const DIMENSION_TO_API_FILTER_KEY = {
  [DIMENSION_TIPO_PAGAMENTO]: 'tipoPagamentos',
  [DIMENSION_INSPECAO]: 'inspecao',
  [DIMENSION_CARTAO]: 'cartaoIds',
};

export const isModularDimension = (dim) =>
  dim && dim !== DIMENSION_GERAL;

export const isSegmentFilterActive = (dim, seg) =>
  isModularDimension(dim) && seg && seg !== SEGMENT_ALL;

const DESCRIPTIONS = {
  [DIMENSION_GERAL]: {
    [SEGMENT_ALL]:
      'Gastos consolidados de todos os colaboradores no período. O ranking destaca quem mais gastou.',
  },
  [DIMENSION_TIPO_PAGAMENTO]: {
    [SEGMENT_ALL]:
      'Compare gastos entre Aporte e Cartão Corporativo. Selecione um segmento para ver KPIs e notas apenas daquele meio.',
    _segment:
      'Exibindo apenas notas pagas via **{label}**.',
  },
  [DIMENSION_INSPECAO]: {
    [SEGMENT_ALL]:
      'Compare gastos de inspeção com demais despesas.',
    _segment:
      'Exibindo apenas notas do recorte **{label}**.',
  },
  [DIMENSION_CARTAO]: {
    [SEGMENT_ALL]:
      'Compare gastos por cartão corporativo.',
    _segment:
      'Exibindo apenas notas do cartão **{label}**.',
  },
};

export const getSegmentDescription = (dim, seg, segmentLabel) => {
  const dimMap = DESCRIPTIONS[dim];
  if (!dimMap) return '';

  if (!isModularDimension(dim) || seg === SEGMENT_ALL) {
    return dimMap[SEGMENT_ALL] || '';
  }

  const template = dimMap._segment || '';
  return template.replace('{label}', segmentLabel || seg);
};

export const getSegmentFilterLabel = (dim, seg, segmentLabel) => {
  if (!isSegmentFilterActive(dim, seg)) return null;
  const tab = DIMENSION_TABS.find((t) => t.id === dim);
  const dimLabel = tab?.label || dim;
  return `${dimLabel}: ${segmentLabel || seg}`;
};

export const STATIC_SEGMENT_OPTIONS = {
  [DIMENSION_TIPO_PAGAMENTO]: [
    { key: 'APORTE', label: 'Aporte' },
    { key: 'CARTAO_CORPORATIVO', label: 'Cartão Corporativo' },
  ],
  [DIMENSION_INSPECAO]: [
    { key: 'true', label: 'Inspeção' },
    { key: 'false', label: 'Outros' },
  ],
};
